(function() {
    'use strict';

    angular.module('product')
        .controller('CategoryUpdateController', CategoryUpdateController);

    CategoryUpdateController.$inject = ['$state', 'categoryDataSrvc', 'notificationSrvc', 'categoryMessagesConst', 'productCountryConst', 'errorNotificationSrvc'];

    function CategoryUpdateController($state, categoryDataSrvc, notificationSrvc, categoryMessagesConst, productCountryConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            title_pl: [],
            title_en: [],
            title_de: [],
            title_cpde: [],
            title_cpen: [],
            description_pl: [],
            description_en: [],
            description_de: [],
            description_cpde: [],
            description_cpen: [],
            title_seo_pl: [],
            title_seo_de: [],
            title_seo_en: [],
            title_seo_cpde: [],
            title_seo_cpen: [],
            description_seo_pl: [],
            description_seo_de: [],
            description_seo_en: [],
            description_seo_cpde: [],
            description_seo_cpen: [],
            keywords_seo_pl: [],
            keywords_seo_de: [],
            keywords_seo_en: [],
            keywords_seo_cpde: [],
            keywords_seo_cpen: [],
            is_published: [],
            parent: [],
            image: [],
            available_in_countries: [],
            nonFieldErrors: []
        };
        self.categoryData = {};
        self.categories = [];
        self.countryList = productCountryConst;

        self.updateCategory = updateCategory;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getCategory();
            getPotentialParents();
        }

        function getCategory() {
            return categoryDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function(response) {
                self.categoryData = response;
                delete self.categoryData.date_added;
                delete self.categoryData.date_modified;
                return response;
            });
        }

        function getPotentialParents() {
            return categoryDataSrvc.categoryParents()
                .$promise.then(function(response) {
                    self.categories = response;
                    return response;
                });
        }

        function updateCategory() {
            categoryDataSrvc.update({
                pk: self.categoryData.pk
            }, self.categoryData).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", categoryMessagesConst.update);
                    $state.go('layout.category.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
